
export default function Location() {
  return (
    <section id="paulinia" className="py-20 bg-gradient-to-b from-red-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-4">
            Visite Nossa Unidade em Paulínia
          </h2>
          <p className="text-xl text-gray-700">
            Estamos prontos para receber você e sua família
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="bg-white rounded-3xl p-8 shadow-xl">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent mb-6">
              Informações de Contato
            </h3>
            
            <div className="space-y-6">
              <a 
                href="https://wa.me/5519989250972"
                className="flex items-start gap-4 p-4 rounded-2xl hover:bg-red-50 transition-colors cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex-shrink-0">
                  <i className="ri-phone-fill text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Telefone</h4>
                  <p className="text-gray-700">(19) 98925-0972</p>
                </div>
              </a>

              <a 
                href="mailto:sacpaulinia@thejoyschool.com.br"
                className="flex items-start gap-4 p-4 rounded-2xl hover:bg-red-50 transition-colors cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-600 to-slate-800 rounded-xl flex-shrink-0">
                  <i className="ri-mail-fill text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">E-mail</h4>
                  <p className="text-gray-700">sacpaulinia@thejoyschool.com.br</p>
                </div>
              </a>

              <div className="flex items-start gap-4 p-4 rounded-2xl">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-500 to-red-600 rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-fill text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Endereço</h4>
                  <p className="text-gray-700">Av. José Pedro de Oliveira, 245 - Jardim America, Paulínia - SP, 13140-693</p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <h4 className="font-bold text-gray-900 mb-4">Siga-nos nas redes sociais</h4>
              <div className="flex gap-4">
                <a 
                  href="https://www.instagram.com/thejoyschoolpaulinia/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 rounded-xl hover:scale-110 transition-transform cursor-pointer shadow-lg"
                >
                  <i className="ri-instagram-fill text-white text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-xl h-[500px]">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.123456789!2d-47.154167!3d-22.761111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c8c7f8f8f8f8f8%3A0x8f8f8f8f8f8f8f8f!2sAv.%20Jos%C3%A9%20Pedro%20de%20Oliveira%2C%20245%20-%20Jardim%20America%2C%20Paul%C3%ADnia%20-%20SP%2C%2013140-693!5e0!3m2!1spt-BR!2sbr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização The Joy School Paulínia"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
